import React from "react"
import { Radium } from "higher-order-components"
import { LoaderIcon } from "components"

const Loading = () => (
  <div
    style={{
      display: "flex",
      flex: "1 1 auto",
      justifyContent: "center",
      textAlign: "center",
      margin: "2em 0"
    }}>
    <LoaderIcon />
  </div>
)
export default Radium()(Loading)



// WEBPACK FOOTER //
// ./src/components/loading/index.jsx